import React from "react";
import { Button } from "../../components/button";
import { Input } from "../../components/input";
import config from "../../config";
import httpUtils from "../../utils/http.utils";

import './style.scss'

export class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = { login: null, password: null, isLog: !!localStorage['token'] };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.renewToken = this.renewToken.bind(this);

        this.renewToken()
    }

    renewToken() {
        setTimeout(() => {
            httpUtils.post(`${config.BACK_API}/api/renewToken`, {}).then((result) => {
                localStorage['token'] = result.data.token;
                this.setState({ isLog: true });
                this.renewToken();
            })
        }, 1000 * 60 * 10) // 10min
    }

    handleChange(fieldName, value) {
        this.setState({ [fieldName]: value })
    }

    handleSubmit() {
        httpUtils.post(`${config.BACK_API}/api/signin`, {
            login: this.state.login,
            password: this.state.password
        }).then((result) => {
            localStorage['token'] = result.data.token;
            this.setState({ isLog: true });
        })
    }

    render() {
        const style = {
            margin: "15px 0"
        };
        return (
            <>
                {
                    !this.state.isLog ?
                        <div className="login-container">
                            < div className="title" >
                                Login
                            </div >

                            <Input type="text" label="login" id="login" onChange={this.handleChange} style={style} />
                            <Input type="password" label="password" id="password" onChange={this.handleChange} style={style} />
                            <Button buttonText="log in" buttonClass="login-button" onClick={this.handleSubmit} />
                        </div >
                        :

                        <>{this.props.children}</>
                }
            </>
        );
    }
}